import { Box } from '@mui/material';

import { ActiveOperations } from './actions-cell';
import FavouriteProductsListCard from './favourite-products-list-card';
import { EnhancedFavouritesItemModel } from './use-favourite-products-list';

interface ResponsiveProductGridProps {
  items: EnhancedFavouritesItemModel[];
  handleQuantityChange: (productStockId: string, delta: number) => void;
  handleUpdate: (cartItemId: string, quantity: number, productId: string) => void;
  handleAddToCart: (productStockId: string, quantity: number, productId: string) => void;
  handleRemoveFromCart: (cartItemId: string, productId: string) => void;
  deleteItem: (itemId: string) => Promise<void>;
  activeOperations: ActiveOperations;
}

export default function FavouriteProductsListGrid({
  items,
  handleQuantityChange,
  handleUpdate,
  handleAddToCart,
  handleRemoveFromCart,
  deleteItem,
  activeOperations,
}: ResponsiveProductGridProps) {
  return (
    <Box
      sx={{
        display: 'grid',
        gap: 2,
        gridTemplateColumns: {
          xs: '1fr', // Mobile: 1 card per row
          sm: 'repeat(2, 1fr)', // Tablet: 2 cards per row
          md: 'repeat(2, 1fr)', // Desktop: 2 cards per row
        },
        p: { xs: 0, sm: 2 },
      }}
    >
      {items.map((product) => (
        <Box key={product.id}>
          <FavouriteProductsListCard
            product={product}
            handleQuantityChange={handleQuantityChange}
            handleUpdate={handleUpdate}
            handleAddToCart={handleAddToCart}
            handleRemoveFromCart={handleRemoveFromCart}
            deleteItem={deleteItem}
            activeOperations={activeOperations}
          />
        </Box>
      ))}
    </Box>
  );
}
